import React, { FC } from 'react';
import { Button, Form, Input, Spin } from 'antd';
import { Navigate } from 'react-router-dom';
import { rules } from 'common/helpers';
import { ERoute } from 'common/const/enum';
import { useAppDispatch, useAppSelector } from 'common/hooks';

export const Login: FC = () => {
  const { auth, authLoading } = useAppSelector((state) => ({
    auth: state.auth.data,
    authLoading: state.auth.loading,
  }));
  const { auth: authDispatch } = useAppDispatch();

  if (auth) {
    return <Navigate to={ERoute.Dashboard} />;
  }

  return (
    <div className="d-flex align-center justify-center flex-1">
      <Form className="box-shadow login__form" onFinish={authDispatch.login}>
        <Spin spinning={authLoading}>
          <div className="ff-medium fs-lg mb-7">Login</div>

          <Form.Item name="email" rules={[rules.required()]}>
            <Input placeholder="E-mail" />
          </Form.Item>

          <Form.Item name="password" rules={[rules.required()]}>
            <Input.Password placeholder="Password" />
          </Form.Item>

          <Form.Item>
            <Button className="blue" htmlType="submit">
              Login
            </Button>
          </Form.Item>
        </Spin>
      </Form>
    </div>
  );
};
